// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-tests-TableDemoPage-TableDemoPage-module__page--qecl5 {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.src-pages-tests-TableDemoPage-TableDemoPage-module__tools--L0rSQ {
  padding: 4px 8px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  background-color: #eee;
}
.src-pages-tests-TableDemoPage-TableDemoPage-module__filters--Asev1 {
  padding: 4px 8px;
  border-bottom: thin solid silver;
}
.src-pages-tests-TableDemoPage-TableDemoPage-module__content--NAMlb {
  flex: 1;
  overflow: auto;
}
/*# sourceMappingURL=TableDemoPage.module.css.map */`, "",{"version":3,"sources":["webpack://./TableDemoPage.module.less","webpack://./src/pages/tests/TableDemoPage/TableDemoPage.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EAEA,aAAA;EACA,sBAAA;ACAF;ADEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;ACAF;ADGA;EACE,gBAAA;EACA,gCAAA;ACDF;ADIA;EACE,OAAA;EACA,cAAA;ACFF;AACA,mDAAmD","sourcesContent":[".page {\n  height: 100%;\n  overflow: auto;\n\n  display: flex;\n  flex-direction: column;\n}\n.tools {\n  padding: 4px 8px;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  background-color: #eee;\n}\n\n.filters {\n  padding: 4px 8px;\n  border-bottom: thin solid silver;\n}\n\n.content {\n  flex: 1;\n  overflow: auto;\n}\n",".page {\n  height: 100%;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n}\n.tools {\n  padding: 4px 8px;\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  background-color: #eee;\n}\n.filters {\n  padding: 4px 8px;\n  border-bottom: thin solid silver;\n}\n.content {\n  flex: 1;\n  overflow: auto;\n}\n/*# sourceMappingURL=TableDemoPage.module.css.map */"],"sourceRoot":""}]);
// Exports
export var page = `src-pages-tests-TableDemoPage-TableDemoPage-module__page--qecl5`;
export var tools = `src-pages-tests-TableDemoPage-TableDemoPage-module__tools--L0rSQ`;
export var filters = `src-pages-tests-TableDemoPage-TableDemoPage-module__filters--Asev1`;
export var content = `src-pages-tests-TableDemoPage-TableDemoPage-module__content--NAMlb`;
export default ___CSS_LOADER_EXPORT___;
